import { Platform, View } from 'react-native';

import { useTheme } from '@savvy/deprecated-shared/hooks/use-theme';

const BORDER_RADIUS = 24;
const SHADOW_COLOR = '#64748B1F';

type Props = {
  readonly children: React.ReactNode;
};

export function XBottomSheet({ children }: Props) {
  const theme = useTheme();
  return (
    <View
      style={{
        borderTopLeftRadius: BORDER_RADIUS,
        borderTopRightRadius: BORDER_RADIUS,
        borderTopColor: SHADOW_COLOR,
        borderTopWidth: 1,
        backgroundColor: theme.palette.background.default,
        // Shadow offset, opacity, and radius don't work for Android so we use elevation
        elevation: Platform.OS === 'android' ? 24 : 0,
        flexDirection: 'column',
        flexGrow: 1,
        paddingHorizontal: 16,
        paddingBottom: 64,
        shadowColor: SHADOW_COLOR,
        shadowOffset: { width: 0, height: -8 },
        shadowOpacity: 1,
        shadowRadius: 6,
      }}
    >
      {children}
    </View>
  );
}
